export const MobileStep = {
  SelectCharges: 0,
  SelectParties: 1,
  ConfigureAmounts: 2,
  ReviewCharges: 3,
} as const;

export type MobileStepValue = typeof MobileStep[keyof typeof MobileStep];
